import { red } from "@mui/material/colors";
import api from "./api";
const endpoint = "/WebsiteRestController";
export const TOKEN = "TOKEN";

const AuthService = {
  async login(authData) {
    try {
      const result = await api.post(endpoint + `/login`, authData);
      if (result && result.data.success) {
        localStorage.clear();
        localStorage.setItem(TOKEN, result.data.data.token);
        localStorage.setItem("user", JSON.stringify(result.data.data));
        // api.defaults.headers.common["Authorization"] = `Bearer ${result.data.data.token}`;
      }

      return result.data;
    } catch (error) {
      localStorage.clear();
      localStorage.removeItem(TOKEN);
      if (error.response) {
        return error.response.data;
      } else {
        return error;
      }
    }
  },
  async changePassword(authData) {
    try {
      const result = await api.post(
        endpoint + `/update_forgoten_password`,
        authData
      );
      return result.data;
    } catch (error) {
      localStorage.clear();
      localStorage.removeItem(TOKEN);
      if (error.response) {
        return error.response.data;
      } else {
        return error;
      }
    }
  },
  async activateAccount(authData) {
    try {
      const result = await api.post(endpoint + `/activate_account`, authData);
      if (result && result.data.success) {
        localStorage.clear();
      }

      return result.data;
    } catch (error) {
      console.log("error: ", error);

      localStorage.clear();
      localStorage.removeItem(TOKEN);
      if (error.response) {
        return error.response.data;
      } else {
        return error;
      }
    }
  },
  async resendActivationLink(authData) {
    try {
      const authDataCopy = {
        ...authData,
        front_url: window.location.href.includes("/forgot-password")
          ? window.location.href.split("/forgot-password")[0] + "/"
          : window.location.href.includes("/login")
            ? window.location.href.split("/login")[0] + "/"
          : window.location.href.includes("/activate-account")
            ? window.location.href.split("/activate-account")[0] + "/"
            : null,
      };
      const result = await api.post(
        endpoint + `/resendActivationMail`,
        authDataCopy
      );
      if (result && result.data.success) {
        localStorage.clear();
      }
      return result.data;
    } catch (error) {
      if (error.response) {
        return error.response.data;
      } else {
        return error;
      }
    }
  },
  async register(userData) {
    try {
      const userDataCopy = {
        ...userData,
        front_url: window.location.href.split("/registration")[0] + "/" || null,
      };
      const result = await api.post(endpoint + `/register`, userDataCopy);
      if (result && result.data.success) {
        localStorage.clear();
        // localStorage.setItem(TOKEN, result.data.data.token);
      }
      return result.data;
    } catch (error) {
      localStorage.clear();
      localStorage.removeItem(TOKEN);
      if (error.response) {
        return error.response.data;
      } else {
        throw error;
      }
    }
  },
  isConnected() {
    const token = localStorage.getItem(TOKEN);
    if (token) {
      api.defaults.headers.common["Authorization"] = token;
      return true;
    }
    return false;
  },
  logOut() {
    localStorage.clear();
    localStorage.removeItem("TOKEN");
    localStorage.removeItem("user");
    api.defaults.headers.common["Authorization"] = null;
    return localStorage.removeItem(TOKEN);
  },
  getUserInfo() {
    const strdata = localStorage.getItem("user");
    return strdata ? JSON.parse(strdata) : null;
  },
  show403Page() {
    window.location.href = process.env.PUBLIC_URL + "/403";
  },
  show404Page() {
    window.location.href = process.env.PUBLIC_URL + "/404";
  },
  loginPage(redirect=null) {
    window.location.href = process.env.PUBLIC_URL + `/login${redirect ? `?rdr=${redirect}` : ""}`;
  },
  navigate(url, blank = false) {
    if (blank) window.open(process.env.PUBLIC_URL + `${url}`, "_blank");
    else window.location.href = process.env.PUBLIC_URL + `${url}`;
  },
};

export default AuthService;
